<template>
  <v-combobox
    :key="props.id"
    v-bind="$attrs"
    v-model:modelValue="value"
    :label="label || t(`entities.${type}.fields.${field}`)"
    :data-cy="type + '-' + props.field"
    multiple
    ref="inputField"
    :readonly="readonly"
    hide-selected>
    <template v-slot:selection="data">
      <v-chip
        v-bind="data.attrs"
        :model-value="data.value"
        size="small"
        closable
        @click:close="removeItem(data.item)">
        {{ data.item.title }}
      </v-chip>
    </template>
  </v-combobox>
</template>

<script setup>
import { useTranslation } from "i18next-vue";
import { inject, computed } from "vue";
import { useSpaceStore } from "../../stores/spaceStore";
import { nextTick, ref } from "vue";
import { useSocketStore } from "@/stores/socketStore";

const spaceStore = useSpaceStore();
const socketStore = useSocketStore();

const { t } = useTranslation();

const props = defineProps({
  id: {
    type: String,
    required: true
  },
  field: {
    type: String,
    required: true
  },
  icon: {
    type: String,
    default: null
  },
  label: {
    type: String,
    default: null
  }
});

const [_, type] = props.id.split("_");

const value = computed({
  get() {
    return spaceStore.calculationElements[props.id][props.field];
  },
  set(newValue) {
    console.log(newValue);
    spaceStore.calculationElements[props.id][props.field] = newValue;
    socketStore.socket.emit(
      "field-input",
      props.id,
      props.field,
      JSON.stringify(newValue)
    );
    updateValue();
  }
});

const readonly = computed(() => {
  return spaceStore.readOnly;
});

// const value = ref("");

function removeItem(item) {
  value.value = value.value.filter((value) => value !== item.value);
}

function updateValue() {
  spaceStore.updateElement(props.id, [props.field]);
}
</script>
